export const billingKeys = {
  all: (orgId: string) => ["billing", orgId] as const,
  detail: (orgId: string) => ["billing", orgId, "subscription"] as const,
  // Plan/price is org-agnostic (the same Stripe price), keyed by price id so an
  // existing subscriber's actual price and the default plan cache separately.
  plan: (priceId: string) => ["billing", "plan", priceId] as const,
};
